

import AddHandleLettersPage from './AddHandleLettersPage.jsx';
import HandleLettersPage from './HandleLettersPage.jsx';
import ThuHoiXuLyDonPage from './ThuHoiXuLyDonPage.jsx';

export {
  AddHandleLettersPage,
  HandleLettersPage,
  ThuHoiXuLyDonPage
};



// WEBPACK FOOTER //
// ./src/components/pages/handle-letters/index.js